import { useFeature } from '@hooks/useFeature';

export function useCopilotUiApiKey(): string | null {
  const tokenEl = document.getElementById('copilot-ui-api-key');
  const hasAiCopilot = useFeature('ai_copilot');

  if (hasAiCopilot && tokenEl && tokenEl instanceof HTMLMetaElement) {
    return tokenEl.content;
  }
  return null;
}
